/* eslint-disable linebreak-style */

export const NOT_FOUND_ERRORS = [
  'could not find item for item id',
  'product(s) not available',
];